import React from 'react';
import { Box, Grid, Text, HStack, Icon } from "@chakra-ui/react";
import { FiUsers, FiCheckCircle, FiMessageSquare, FiXCircle } from "react-icons/fi";
import { LuMailOpen, LuMousePointerClick } from 'react-icons/lu';

const formatCompact = (num) => {
    const n = Number(num);
    if (isNaN(n)) return '0';
    if (n >= 1_000_000_000) return `${+(n / 1_000_000_000).toFixed(1)}B`;
    if (n >= 1_000_000)     return `${+(n / 1_000_000).toFixed(1)}M`;
    if (n >= 1_000)         return `${+(n / 1_000).toFixed(1)}K`;
    return n;
};

const StatCard = ({ label, value, subText, icon, iconColor, iconBg, valueColor }) => (
    <Box p={4} borderRadius="xl" bg="white" className="box-style-card">
        <HStack justify="space-between" align="flex-start" mb={3}>
            <Text fontSize="sm" color="gray.500">{label}</Text>
            <Box w={10} h={10} bg={iconBg} borderRadius="lg" display="flex" alignItems="center" justifyContent="center" flexShrink={0}>
                <Icon as={icon} boxSize={5} color={iconColor} />
            </Box>
        </HStack>
        <Text fontSize="3xl" fontWeight="semibold" color={valueColor ?? 'gray.800'} lineHeight="1.1">
            {value ?? 0}
        </Text>
        {subText && (
            <Text fontSize="xs" color="gray.500" mt={1}>{subText}</Text>
        )}
    </Box>
);

const MetricsCards = ({ data }) => {
    const m = data?.metrics;

    return (
        <Box w="100%">
            <Grid templateColumns="repeat(6, 1fr)" gap={4}>
                <StatCard
                    label="Total Contacts"
                    value={formatCompact(m?.total_contacts ?? 0)}
                    icon={FiUsers}
                    iconColor="var(--brand-primary)"
                    iconBg="var(--brand-tint)"
                />
                <StatCard
                    label="Messages Sent"
                    value={formatCompact(m?.messages_sent?.count ?? 0)}
                    subText={`Success Rate: ${m?.messages_sent?.success_rate_percent ?? 0}%`}
                    icon={FiCheckCircle}
                    iconColor="#16a34a"
                    iconBg="#f0fdf4"
                    valueColor="#16a34a"
                />
                <StatCard
                    label="Delivered"
                    value={formatCompact(m?.delivered?.count ?? 0)}
                    subText={`Delivery Rate: ${m?.delivered?.delivery_rate_percent ?? 0}%`}
                    icon={FiMessageSquare}
                    iconColor="#9333ea"
                    iconBg="#faf5ff"
                    valueColor="#9333ea"
                />
                <StatCard
                    label="Read"
                    value={formatCompact(m?.read?.count ?? 0)}
                    subText={`Read Rate: ${m?.read?.read_rate_percent ?? 0}%`}
                    icon={LuMailOpen}
                    iconColor="var(--brand-primary-hover)"
                    iconBg="var(--brand-50)"
                    valueColor="var(--brand-primary-hover)"
                />
                <StatCard
                    label="Clicked"
                    value={formatCompact(m?.clicked?.count ?? 0)}
                    subText={`Click Rate: ${m?.clicked?.click_rate_percent ?? 0}%`}
                    icon={LuMousePointerClick}
                    iconColor="#ea580c"
                    iconBg="#fff7ed"
                    valueColor="#ea580c"
                />
                <StatCard
                    label="Failed"
                    value={formatCompact(m?.failed?.count ?? 0)}
                    subText={`${m?.failed?.percent_of_total ?? 0}% of total`}
                    icon={FiXCircle}
                    iconColor="#dc2626"
                    iconBg="#fef2f2"
                    valueColor="#dc2626"
                />
            </Grid>
        </Box>
    );
};

export default MetricsCards;
